// "Signed in as <email>" header with a brand-themed avatar (first letter of
// the email). Falls back to the `sub` when the BFF claims carry no email.
// Brand accent comes from the tenant registry so the avatar matches theme.

import { resolveTenant, TENANTS } from "./brand";

interface IdentityHeaderProps {
  /** Signup email; may be undefined for sessions without one. */
  email?: string;
  /** Stable subject id, used as the fallback identity. */
  sub: string;
}

export function IdentityHeader({ email, sub }: IdentityHeaderProps) {
  const identity = email ?? sub;
  const initial = (identity.trim()[0] ?? "?").toUpperCase();
  const accent = TENANTS[resolveTenant()].brand.paletteAccent;

  return (
    <div
      className="hub-identity"
      data-hub-identity
      style={{ ["--hub-brand-accent" as string]: accent }}
    >
      <span className="hub-avatar" aria-hidden="true">
        {initial}
      </span>
      <span className="hub-identity-meta">
        <span className="hub-identity-label">Signed in as</span>
        <span className="hub-identity-value" data-hub-identity-value>
          {identity}
        </span>
      </span>
    </div>
  );
}
